import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EsignatureConfigListStore } from "../../store/EsignatureConfigListStore";

type EsignatureConfigListDialogsProps = {
  store: EsignatureConfigListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EsignatureConfig.
 * Separado para mantener EsignatureConfigListPage más limpio.
 */
export const EsignatureConfigListDialogs: React.FC<EsignatureConfigListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
